import { Breadcrumb } from "antd";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";

const BreadcrumbComponent = () => {
  const resourcesState = useSelector((state: RootState) => state.resources);
  return (
    <Breadcrumb style={{ color: "inherit" }}>
      <Breadcrumb.Item>
        <FormattedMessage
          id="report.container.breadcrumb.item.resources"
          defaultMessage="Signal"
        />
      </Breadcrumb.Item>
      <Breadcrumb.Item>{resourcesState.resourceSelected?.name}</Breadcrumb.Item>
    </Breadcrumb>
  );
};
export default BreadcrumbComponent;
